import React from 'react';
import './Contact.css';
import HeroSectionContact from '../../components/hero_section_contact/HeroSectionContact';
import Header2 from '../../components/header/Header2';
import ContactForm from '../../components/contact_form/ContactForm';
import ContactInfo from '../../components/contact_info/ContactInfo';
import Footer from '../../components/footer/Footer';
import SocialMediaSection from '../../components/social_media_section/SocialMediaSection';
import GoogleMapOffice from '../../components/google_map_office/GoogleMapOffice';
import WhatsappCallBtn from '../../components/whatsapp_call_btn/WhatsappCallBtn';
import { Helmet } from "react-helmet";
export default function Contact() {
  return (
   <>
   <Helmet>
  <title>
    Contact Us | GlassHopeOne Technologies Pvt. Ltd. – Enterprise Software & SaaS Company
  </title>

  <meta
    name="description"
    content="Get in touch with GlassHopeOne Technologies Pvt. Ltd. to discuss enterprise software development, SaaS platforms, web applications, and mobile app solutions. Let’s build scalable and impactful digital products together."
  />

  <meta
    name="keywords"
    content="contact GlassHopeOne Technologies, enterprise software company contact, SaaS development company India, web and mobile app development contact"
  />

  <meta name="author" content="GlassHopeOne Technologies Pvt. Ltd." />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <link rel="canonical" href="https://www.glasshopeone.com/contact-us" />
</Helmet>

   <Header2/>
   <HeroSectionContact/>
   <ContactForm/>
   <ContactInfo/>
   <SocialMediaSection/>
   <GoogleMapOffice/>
   <WhatsappCallBtn/>
   <Footer/>
   
   
   </>
  )
}
